import React, { Component } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { PublicLayout } from './components/PublicLayout';
import { PublicLayoutLarge } from './components/PublicLayoutLarge';
import { Login } from './components/login/Login';
import { VerifyReset } from './components/accountActivation/VerifyReset';
import { PasswordReset } from './components/login/PasswordReset';
import { Verify } from './components/accountActivation/Verify';
import { NetworkActivation } from './components/accountActivation/NetworkActivation';
import { AccountActivation } from './components/accountActivation/AccountActivation';
import { VerifyResetPassword } from './components/login/VerifyResetPassword';
import { ResetPasswordSuccess } from './components/login/ResetPasswordSuccess';
import { Register } from './components/accountActivation/Register';
import { RegistrationComplete } from './components/accountActivation/RegistrationComplete';
import { PasswordResetComplete } from './components/login/PasswordResetComplete';
import { TestConn } from './components/TestConn';
import { library } from '@fortawesome/fontawesome-svg-core';
import './css/site.css';
import './css/tcoe.css';
import { faPlus, faMinus, faHome, faEye, faEyeSlash, fas} from '@fortawesome/free-solid-svg-icons';
library.add(faPlus, faMinus, faHome, faEye, faEyeSlash, fas);

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
        <div className="fullHeight">
            <Routes>
                <Route element={<PublicLayout />}>
                    <Route exact path="login" element={<Login />} />
                    <Route exact path="VerifyReset" element={<VerifyReset />} />
                    <Route exact path="Verify" element={<Verify />} />
                    <Route exact path="VerifyResetPassword" element={<VerifyResetPassword />} />
                    <Route exact path="ResetPasswordSuccess" element={<ResetPasswordSuccess />} />
                    <Route exact path="Register" element={<Register />} />
                    <Route exact path="RegistrationComplete" element={<RegistrationComplete />} />
                    <Route exact path="PasswordReset" element={<PasswordReset />} />
                    <Route exact path="PasswordResetComplete" element={<PasswordResetComplete />} />
                    <Route exact path="NetworkActivation" element={<NetworkActivation />} />
                    <Route exact path="AccountActivation" element={<AccountActivation />} />
                    <Route exact path="testconn" element={<TestConn />} />
                </Route>
                <Route path="/TermsOfService" component={<PublicLayoutLarge />} />
                <Route path='/*' element={<Layout />} />
            </Routes>
      </div>
    );
  }
}
